export const environment = {
  production: true,
    environmentName: 'PROD',
    paymentApiURL: "#{paymentApiURL}#",
    apiUrl: "#{apiURL}#"
};
